// extracted by mini-css-extract-plugin
module.exports = {"userCard":"ControlledAutocomplete_userCard__2rZuF","input":"ControlledAutocomplete_input__1cUOz","resultsWrapper":"ControlledAutocomplete_resultsWrapper__3SgGv"};